import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'



export const stuffRuleOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "员工编码",
            prop: "code",
            type: 'input',
            editVisdiplay:false,
        },
        {
            label: "员工姓名",
            prop: "name",
            search:true,
            editVisdiplay:false,
        },
        {
            label: "员工账号",
            prop: "account",
            editVisdiplay:false,
        },
        {
            label: "部门名称",
            prop: "departmentName",
            editVisdiplay:false,
        },
        {
            label: "申请积分上限",
            prop: "applyPointMax",
            placeholder: "部门员工的申请积分上限",
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                message: "部门员工的申请积分上限"
            }]
        },
        // {
        //     label: "更新时间",
        //     prop: "updateTime",
        //     type: "datetime",
        //     // sortable: true,
        //     valueFormat: "timestamp",
        //     format: "yyyy-MM-dd HH:mm:ss",
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "更新人",
        //     prop: "updateBy",
        //     type: "input",
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     width: "110"
        // },
    ]
};